import Vue from 'vue'

export default {
  props: {
    useExcel: {
      type: Boolean,
      default: false
    },
    itemPerPage: {
      type: Number,
      default: 10
    },
    tableClass: null,
    emptyText: {
      type:String,
      default: '조회 결과가 없습니다.'
    },
    sourceList: Array,
    checkedList: Array
  },
  data() {
    return {
      clonedList: null,
      currentPage: 0,
      columnNum: 1
    }
  },
  watch: {
    sourceList() {
      this.cloneSourceList()
      this.$nextTick(this.setColumnNum)
      let currentPage = Math.min(this.currentPage, this.totalPagesNum - 1)
      if (currentPage < 0) currentPage = 0
      this.currentPage = currentPage
    },
    currentList(newValue, oldValue) {
      oldValue && oldValue.forEach(item => item._checked = false)
    },
    checkedList_local(val) {
      this.$emit('update:checkedList', val)
    }
  },
  computed: {
    totalPagesNum() {
      if (_.isEmpty(this.clonedList)) return 0
      return Math.ceil(this.clonedList.length / this.itemPerPage)
    },
    currentList() {
      if (_.isEmpty(this.clonedList)) return null
      const start = this.itemPerPage * this.currentPage
      return this.clonedList.slice(start, start + this.itemPerPage)
    },
    isAllChecked() {
      if (_.isEmpty(this.currentList)) return false
      return !this.currentList.some(item => item._checked === false)
    },
    isItemChecked() {
      if (_.isEmpty(this.currentList)) return false
      return this.currentList.some(item => item._checked === true)
    },
    isAllUnchecked() {
      if (_.isEmpty(this.currentList)) return false
      return !this.currentList.some(item => item._checked === false)
    },
    checkedList_local() {
      if (!this.currentList) return null
      return this.currentList.filter(item => item._checked)
    }
  },
  methods: {
    getTable() {
      return this.$refs.table
    },
    getExcelTable() {
      return this.$refs.excelTable || this.$refs.table
    },
    cloneSourceList() {
      this.clonedList = _.map(this.sourceList, (item, index) => {
        Vue.set(item, '_index', this.sourceList.length - index - 1)
        Vue.set(item, '_checked', false)
        return item
      })
    },
    setColumnNum() {
      if (!this.$el) {
        this.columnNum = 1
        return
      }
      let result = 0
      _.forEach(this.$el.querySelector('thead tr').querySelectorAll('th'), td => result += td.colSpan ? td.colSpan : 1)
      this.columnNum = result
    },
    resetState() {
      this.$emit('resetState')
    },
    toggleChecked() {
      let value = !this.isAllChecked
      this.currentList.forEach(item => item._checked = value)
    },
    getCheckedItems() {
      return this.checkedList_local
    }
  },
  mounted() {
    if (!_.isEmpty(this.sourceList)) this.cloneSourceList()
    this.$on('resetState', () => this.currentPage = 0)
    this.setColumnNum()
  }
}